import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "library-album-files" }
const _hoisted_3 = { class: "library-audio-files-table" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "library-nowrap-text" }
const _hoisted_6 = { class: "library-nowrap-text" }
const _hoisted_7 = { class: "library-audio-files-table-duration" }
const _hoisted_8 = { class: "library-audio-files-table-rating" }
const _hoisted_9 = { class: "library-audio-files-table-count" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_14 = { class: "library-album-table-duration" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_audio_rating = _resolveComponent("audio-rating")!

  return (_ctx.album)
    ? (_openBlock(), _createElementBlock("table", {
        key: 0,
        class: "library-album",
        style: _normalizeStyle(_ctx.styleObjectAlbum)
      }, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            class: "library-album-img-td",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAudioAlbum(_ctx.album)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.album.artist), 1),
            _createElementVNode("img", {
              class: "library-album-img",
              loading: "lazy",
              src: 'https://backend.vdmar.ru/storage/images/' + _ctx.album.id + '/2.jpg'
            }, null, 8, _hoisted_1),
            _createElementVNode("span", null, _toDisplayString(_ctx.album.year + " - " + _ctx.album.name), 1)
          ]),
          _createElementVNode("td", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audioFilesPreview, (audioFile) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: audioFile.id,
                  class: _normalizeClass(["library-audio-files-table-tr", audioFile.selected ? 'library-audio-files-table-tr-selected' : '']),
                  style: _normalizeStyle(audioFile.state == 1 || audioFile.state == 2 ? 'display: none' : 'display: table-row'),
                  onClick: ($event: any) => (_ctx.selectAudioTrack(audioFile))
                }, [
                  _createElementVNode("td", {
                    class: "library-audio-files-table-name",
                    style: _normalizeStyle(_ctx.styleObjectTableName)
                  }, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(audioFile.trackNo + ' . ' + audioFile.title), 1)
                  ], 4),
                  _createElementVNode("td", {
                    class: "library-audio-files-table-genre",
                    style: _normalizeStyle(_ctx.styleObjectGenre)
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(audioFile.genre), 1)
                  ], 4),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.getAudioFileLastDuration(+audioFile.duration)), 1),
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(_component_audio_rating, {
                      rating: audioFile.rating,
                      fileId: audioFile.id
                    }, null, 8, ["rating", "fileId"])
                  ]),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(audioFile.count != 0 ? audioFile.count : ''), 1),
                  _createElementVNode("td", {
                    class: "library-audio-files-table-lastPlayed",
                    style: _normalizeStyle(_ctx.styleObjectLastPlayed)
                  }, _toDisplayString(audioFile.count != 0 ? _ctx.getAudioFileLastPlayed(audioFile.lastPlayed) : ''), 5)
                ], 14, _hoisted_4))
              }), 128)),
              (_ctx.album.audioFiles.length < 10)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((10 - _ctx.album.audioFiles.length), (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      style: {"height":"17px"}
                    }, _hoisted_11))
                  }), 128))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                (_ctx.album.audioFiles.filter((el) => el.state !== 1 && el.state !== 2).length >= 11)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      class: "library-audio-files-table-add",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fullAlbum = !_ctx.fullAlbum))
                    }, _toDisplayString(_ctx.fullAlbum ? 'Убрать' : 'Показать все ' + _ctx.album.audioFiles.filter((el) =>
                                    el.state !== 1 && el.state !== 2).length + ' трэков'), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_12)),
                _hoisted_13,
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.getAlbumDuration(_ctx.album)), 1),
                _hoisted_15,
                _hoisted_16,
                _hoisted_17
              ])
            ])
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}